import script from "./KeepInTouchOptIn.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeepInTouchOptIn.vue?vue&type=script&lang=ts&setup=true"

import "./KeepInTouchOptIn.vue?vue&type=style&index=0&id=06c58b9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c58b9e"]])

export default __exports__